package com.essntl.features.invoice.ui.addeditinvoice.components.content.extraservice

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.features.service.domain.model.extraservice.ExtraServiceModel
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ExtraServiceItem(
    extraService: ExtraServiceModel,
    onRemove: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier,
    ) {
        Column(
            horizontalAlignment = Alignment.Start,
            modifier = Modifier
                .weight(1f),
        ) {
            Text(
                text = extraService.service.title,
                style = MaterialTheme.esTypography.p1Bold16,
                color = MaterialTheme.esColorScheme.textPrimary,
                modifier = Modifier.fillMaxWidth(),
            )

            Text(
                text = extraService.description ?: "",
                style = MaterialTheme.esTypography.p2Regular14,
                color = MaterialTheme.esColorScheme.textSecondary,
                modifier = Modifier.fillMaxWidth(),
            )
        }

        Spacer(modifier = Modifier.width(3.spacing))

        if ((extraService.quantity ?: 1) > 1)
            Text(
                text = "x${extraService.quantity}",
                style = MaterialTheme.esTypography.s2SemiBold16,
                color = MaterialTheme.esColorScheme.textPrimary,
                modifier = Modifier
                    .padding(end = 3.spacing),
            )

        Text(
            text = "$${formatIntMoney(extraService.unitPrice ?: 0)}",
            style = MaterialTheme.esTypography.p1Bold16,
            color = MaterialTheme.esColorScheme.textSecondary,
        )

        Spacer(modifier = Modifier.width(2.spacing))

        EsMediumOutlineIconButton(
            onClick = onRemove,
            iconRes = EsIcons.Close,
        )
    }
}